export default class TextExpand {
    private static readonly MOBILE_BREAKPOINT = 768;
    private static readonly MOBILE_LINE_LIMIT = 3;
    private static readonly DESKTOP_LINE_LIMIT = 2;
    private static readonly RESIZE_DEBOUNCE_MS = 250;

    private static resizeTimer: number | undefined;
    private static isInitialized = false;

    static init(): void {
        const textWrappers = document.querySelectorAll<HTMLElement>('.category-header__text');

        if (textWrappers.length === 0) {
            return;
        }

        textWrappers.forEach((wrapper) => this.initializeWrapper(wrapper));

        if (!this.isInitialized) {
            this.handleResize();
            this.isInitialized = true;
        }
    }

    private static initializeWrapper(wrapper: HTMLElement): void {
        const contentText = wrapper.querySelector<HTMLElement>('.content-text');
        const trigger = wrapper.querySelector<HTMLElement>('.content-text__trigger');

        if (!contentText || !trigger) {
            return;
        }

        const triggerInfos = trigger.querySelectorAll<HTMLElement>('.content-text__trigger-info');

        if (triggerInfos.length !== 2) {
            return;
        }

        // Nejdřív aplikujeme collapsed stav
        wrapper.classList.add('category-header__text--collapsed');
        contentText.classList.add('content-text--collapsed');

        // Pak zkontrolujeme, jestli je text skutečně oříznutý
        if (!this.isTextOverflowing(contentText)) {
            trigger.style.display = 'none';
            wrapper.classList.remove('category-header__text--collapsed');
            contentText.classList.remove('content-text--collapsed');
            return;
        }

        trigger.style.display = '';
        this.attachTriggerListener(trigger, contentText, triggerInfos);
    }

    private static attachTriggerListener(
        trigger: HTMLElement,
        contentText: HTMLElement,
        triggerInfos: NodeListOf<HTMLElement>,
    ): void {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            contentText.classList.toggle('content-text--collapsed');
            triggerInfos.forEach((info) => {
                info.classList.toggle('is-active');
            });
        });
    }

    private static handleResize(): void {
        window.addEventListener('resize', () => {
            if (this.resizeTimer !== undefined) {
                clearTimeout(this.resizeTimer);
            }
            this.resizeTimer = window.setTimeout(() => {
                this.reinit();
            }, this.RESIZE_DEBOUNCE_MS);
        });
    }

    private static isTextOverflowing(element: HTMLElement): boolean {
        // Kontrolujeme, jestli je scrollHeight větší než clientHeight
        // To znamená, že obsah je oříznutý CSS (line-clamp nebo max-height)
        return element.scrollHeight > element.clientHeight;
    }

    static reinit(): void {
        const textWrappers = document.querySelectorAll<HTMLElement>('.category-header__text');

        textWrappers.forEach((wrapper) => {
            this.resetWrapper(wrapper);
        });

        this.init();
    }

    private static resetWrapper(wrapper: HTMLElement): void {
        const trigger = wrapper.querySelector<HTMLElement>('.content-text__trigger');
        const contentText = wrapper.querySelector<HTMLElement>('.content-text');

        if (trigger) {
            // Odstranění event listenerů klonováním
            const newTrigger = trigger.cloneNode(true) as HTMLElement;
            trigger.replaceWith(newTrigger);
        }

        contentText?.classList.remove('content-text--collapsed');
        wrapper.classList.remove('category-header__text--collapsed');
    }

    static destroy(): void {
        if (this.resizeTimer !== undefined) {
            clearTimeout(this.resizeTimer);
        }
        this.isInitialized = false;
    }
}
